import useSWR from 'swr';
import useSdk from 'helpers/hooks/useSdk';
import { revalidateOptions } from 'frontastic';

const useShippyProMapsApiKey = () => {
  const sdk = useSdk();
  const result = useSWR(
    `/action/shippypro/getShippyProMapsApiKey`,
    () => {
      return sdk.callAction<{ mapsApiKey: string }>({
        actionName: 'shippypro/getShippyProMapsApiKey',
      });
    },
    revalidateOptions,
  );

  return result.data?.isError ? undefined : result.data?.data.mapsApiKey;
};

export default useShippyProMapsApiKey;
